import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MobileCheckGuard implements CanActivate {

    showmobile = new BehaviorSubject<boolean>(false);

    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
            if (isMobile) {
                this.showmobile.next(true);
                resolve(true); // Route erlauben
            } else {
                this.showmobile.next(window.innerWidth < 768);
                window.onresize = () => {
                    this.showmobile.next(window.innerWidth < 768);
                }
                resolve(true); // Route erlauben (war false - das hat die Route blockiert!)
            }
        });
    }
}
